import React from 'react';
import QureHeader from './QureHeader';
import './QureLayout.css';

const QureLayout = ({ children }) => {
  return (
    <div className="qure-body">
      <QureHeader />
      <main className="qure-main">
        {children}
      </main>
    </div>
  );
};

export default QureLayout;
